import React from 'react';
import { Form, Input, Select, Button, Icon, Row, Col, Tag } from 'antd';
import styled from 'styled-components';
import uid from 'uid';

var Option = Select.Option;

var FieldCard = styled.div`
  background: #fafafa;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 10px;
  position: relative;
  transition: all 0.15s;

  &:hover {
    border-color: #d9d9d9;
  }

  .ant-form-item { margin-bottom: 0; }
  .ant-form-item-label { line-height: 1.5; padding-bottom: 2px; }
  .ant-form-item-label label { font-size: 12px; font-weight: 500; color: #8c8c8c; }
`;

var FieldHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
`;

var FieldNumber = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
  color: #595959;
`;

var AddButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 14px;
  border: 2px dashed #d9d9d9;
  border-radius: 8px;
  color: #8c8c8c;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s;
  margin-top: 4px;

  &:hover {
    border-color: #722ed1;
    color: #722ed1;
    background: #f9f0ff;
  }
`;

var EmptyState = styled.div`
  text-align: center;
  padding: 24px 0;
  color: #bfbfbf;
`;

var TYPE_LABELS = { text: 'Texto', money: 'Dinheiro' };
var TYPE_COLORS = { text: '#1890ff', money: '#52c41a' };

var InputFields = function(props) {
  var fields = props.fields;
  var setFields = props.setFields;
  var form = props.form;
  var getFieldDecorator = form.getFieldDecorator;

  var handleAdd = function() {
    setFields([].concat(fields, [{
      name: '',
      type: 'text',
      id: uid(10)
    }]));
  };

  var handleDelete = function(index) {
    setFields(fields.filter(function(f, i) { return i !== index; }));
  };

  if (fields.length === 0) {
    return React.createElement('div', null,
      React.createElement(EmptyState, null,
        React.createElement(Icon, { type: 'edit', style: { fontSize: 32, marginBottom: 8, display: 'block' } }),
        React.createElement('span', { style: { fontSize: 13 } }, 'Nenhum campo personalizado'),
        React.createElement('div', { style: { fontSize: 11, marginTop: 4 } }, 'Adicione campos para coletar informações extras por cliente')
      ),
      React.createElement(AddButton, { onClick: handleAdd },
        React.createElement(Icon, { type: 'plus' }),
        'Adicionar campo'
      )
    );
  }

  return React.createElement('div', null,
    fields.map(function(row, index) {
      return React.createElement(FieldCard, { key: row.id },
        React.createElement(FieldHeader, null,
          React.createElement(FieldNumber, null,
            React.createElement(Icon, { type: 'drag', style: { color: '#d9d9d9' } }),
            'Campo ' + (index + 1)
          ),
          React.createElement(Button, {
            type: 'link',
            size: 'small',
            style: { color: '#ff4d4f', fontSize: 12 },
            onClick: function() { handleDelete(index); }
          },
            React.createElement(Icon, { type: 'delete' }),
            ' Remover'
          )
        ),
        React.createElement(Row, { gutter: 12 },
          React.createElement(Col, { span: 16 },
            React.createElement(Form.Item, { label: 'Nome do campo' },
              getFieldDecorator('fields[' + row.id + '][0]', {
                initialValue: row.value,
                rules: [{ required: true, message: 'Informe o nome' }],
              })(React.createElement(Input, {
                placeholder: 'Ex: Valor do faturamento',
                onChange: function(e) {
                  setFields(fields.map(function(item) {
                    if (item.id !== row.id) return item;
                    return Object.assign({}, item, { value: e.target.value });
                  }));
                }
              }))
            )
          ),
          React.createElement(Col, { span: 8 },
            React.createElement(Form.Item, { label: 'Tipo' },
              getFieldDecorator('fields[' + row.id + '][1]', {
                initialValue: row.type,
                rules: [{ required: true, message: 'Selecione' }],
              })(React.createElement(Select, { placeholder: 'Tipo' },
                React.createElement(Option, { value: 'text' }, 'Texto'),
                React.createElement(Option, { value: 'money' }, 'Dinheiro')
              ))
            )
          )
        )
      );
    }),
    React.createElement(AddButton, { onClick: handleAdd },
      React.createElement(Icon, { type: 'plus' }),
      'Adicionar campo'
    )
  );
};

export default InputFields;
